export default __webpack_public_path__ + "static/media/logo192.5e7f8ec4.png";